<template>
  <div class="header-mobile">
    <ContainerInner class="header-mobile__inner">
      <ElementBrand class="header-mobile__brand" />
      <ElementToggle class="header-mobile__toggle" :active="activeToggle" @click="handleToggle" />
    </ContainerInner>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContainerInner from '@containers/ContainerInner'
import ElementToggle from '@elements/ElementToggle'
import ElementBrand from '@elements/ElementBrand'

export default {
  name: 'TheHeaderMobile',
  components: {
    ContainerInner,
    ElementBrand,
    ElementToggle
  },
  data () {
    return {
      activeToggle: false
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      open: 'header/getOpen'
    })
  },
  watch: {
    // device () {
    //   this.activeToggle = false
    // },
    open () {
      this.activeToggle = this.open
    }
  },
  methods: {
    ...mapActions({
      updateOpen: 'header/updateOpen'
    }),
    handleToggle () {
      this.updateOpen(!this.open)
    }
  }
}
</script>

<style lang="scss">
  .header-mobile{
    position: relative;
    background-color: colors("background");
    padding-top: layout("spacing")/2;
    padding-bottom: layout("spacing")/2;

    &__inner{
      display: flex;
      justify-content: space-between;
      align-items: center;

      > *{
        flex: 0 1 auto;
      }
    }

    // Brand

    &__brand{
      @include media("small-medium"){
        width: 17.2rem;
        height: 8rem;
      }
      @include media("large"){
        width: 20rem;
        height: 9.3rem;
        flex: 0 1 auto;
      }
    }

    // Toggle

    &__toggle{
      @include media("small-medium"){
        flex: 0 1 auto;
      }
      @include media("large"){
        display: none;
      }
    }
  }
</style>
